<template>
  <svg
    class="universkin-logo"
    :class="classes"
    width="34"
    height="25"
    viewBox="0 0 34 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.3215 25H34L33.9997 22.5455V21.1818C33.9997 21.1818 33.9997 11.3636 33.9997 11.2727C34.0451 5.04545 28.8249 0 22.379 0C20.4725 0 18.6113 0.454545 17.0225 1.27273C15.4338 0.454545 13.5726 0 11.6661 0C5.22025 0 0 5.04545 0 11.2727C0 11.3636 0 21.1818 0 21.1818V22.5455V25H2.72361V22.5455C5.49261 22.5455 11.5753 22.5455 11.6661 22.5455C13.618 22.5455 15.4338 22.0909 17.0225 21.2727C18.6113 22.0909 20.4725 22.5455 22.379 22.5455C22.4698 22.5455 28.5525 22.5455 31.3215 22.5455V25ZM11.7569 20C11.6661 20 5.49261 20 2.67821 20V11.4091V11.3636C2.67821 6.59091 6.76363 2.72727 11.7569 2.72727C12.7102 2.72727 13.6634 2.86364 14.5259 3.13636C12.2562 5.22727 10.8036 8.13636 10.8036 11.3636C10.8036 14.5909 12.2108 17.5455 14.5259 19.5909C13.6634 19.8636 12.7556 20 11.7569 20ZM17.0225 18.0909C14.7983 16.5 13.3911 14 13.3911 11.1818C13.3911 8.36364 14.7983 5.81818 17.0225 4.27273C19.2468 5.86364 20.654 8.36364 20.654 11.1818C20.654 14 19.2468 16.5 17.0225 18.0909ZM22.2882 20C21.3349 20 20.3817 19.8636 19.5192 19.5909C21.7889 17.5 23.2415 14.5909 23.2415 11.3636C23.2415 8.13636 21.8343 5.18182 19.5192 3.13636C20.3817 2.86364 21.3349 2.72727 22.2882 2.72727C27.2815 2.72727 31.3669 6.59091 31.3669 11.3636V11.4091V20C28.5525 20 22.379 20 22.2882 20Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {
  name: 'UniverskinLogo',
  props: {
    /* 'black' or 'white' */
    color: {
      type: String,
      default: 'black'
    }
  },
  computed: {
    classes() {
      return {
        'universkin-logo--white': this.color === 'white'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.universkin-logo {
  path {
    fill: black;
  }

  &--white {
    path {
      fill: white;
    }
  }
}
</style>
